import * as Sentry from '@sentry/react';

/**
 * Sentryにエラーを送信する共通関数
 * @param error エラーオブジェクト
 * @param action アクション名（タグとして使用、オプション）
 * @param options 追加のオプション（タグ、コンテキストなど）
 */
export const captureSentryException = (
  error: unknown,
  action?: string,
  options?: {
    tags?: Record<string, string>;
    contexts?: Record<string, unknown>;
  }
): void => {
  const sentryOptions: Parameters<typeof Sentry.captureException>[1] = {
    tags: {
      ...(action && { action }),
      ...(options?.tags && options.tags),
    },
  };

  if (options?.contexts) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    sentryOptions.contexts = options.contexts as any;
  }

  Sentry.captureException(error, sentryOptions);
};
